module.exports = __webpack_public_path__ + "img/banco.b9cb960b.svg";